import React from 'react'
import {
  Route,
  Switch,
  useRouteMatch,
  RouteComponentProps,
} from 'react-router-dom'
import ErrorBoundary from 'components/ErrorBoundary'
import LicenseSearch from './Search/LicenseSearch'
import License from './LicenseManager'

type LicenseRouteParams = {
  id: string
}

export interface LicenseProps extends RouteComponentProps<LicenseRouteParams> {}

const LicenseRouter: React.FC = () => {
  const match = useRouteMatch()

  return (
    <ErrorBoundary>
      <Switch>
        <Route
          path={`${match.path}/:id`}
          render={(props: LicenseProps) => <License {...props} />}
        />
        <Route
          path={match.path}
          render={props => <LicenseSearch {...props} />}
        />
      </Switch>
    </ErrorBoundary>
  )
}

export default LicenseRouter
